import { Box, Container, SegmentedControl } from '@amzn/awsui-components-core';
import React, { useState } from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import '../../resources/styles/scss/components/pages/content/ContentHistory.css';
interface Props {
  oldValue: object;
  newValue: object;
  compareMethod?: DiffMethod;
  leftTitle?: string;
  rightTitle?: string;
  inlineHeader?: string;
}

const DiffView = (props: Props) => {
  const { oldValue, newValue, compareMethod, leftTitle, rightTitle, inlineHeader } = props;
  const [splitView, setSplitView] = useState(true);
  const leftHeader = splitView ? leftTitle : inlineHeader;
  const rightHeader = splitView ? rightTitle : null;

  return (
    <Container
      header={
        <SegmentedControl
          selectedId={splitView ? 'split' : 'inline'}
          onChange={({ detail }) => setSplitView(detail.selectedId === 'split')}
          options={[
            { id: 'inline', text: 'Inline' },
            { id: 'split', text: 'Side-by-side' },
          ]}
        />
      }
    >
      <div className="diff-viewer-div">
        <ReactDiffViewer
          oldValue={JSON.stringify(oldValue, null, 2)}
          newValue={JSON.stringify(newValue, null, 2)}
          compareMethod={compareMethod || DiffMethod.WORDS}
          splitView={splitView}
          leftTitle={<Box variant="h2">{leftHeader}</Box>}
          rightTitle={<Box variant="h2">{rightHeader}</Box>}
          // Compute the diff on the main thread: the viewer's Web Worker loads from a blob: URL, which our CSP blocks
          disableWorker
        />
      </div>
    </Container>
  );
};

export default DiffView;
